



































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
//import Swiper from "swiper";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import VueSeamlessScroll from "vue-seamless-scroll";
let echarts = require("echarts");
  // require("echarts/lib/chart/line");
  // require("echarts/lib/component/tooltip");
  // require("echarts/lib/component/title");
class PageThRealTimeDataRequest extends PageRequest {}
@Component({
  components: { VueSeamlessScroll },
})
export default class aMaps extends AbpBase {
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  equlist = [];
  thlist = [];
  Inlist = [];
  elist = [];
  Inlocation = [];
  mySwiper: null;
  gaslist = [];
  traplist = null;
  warninglist = null;
  templist = [4, 3, 2, 1];
  speed: Number = 120000;
  dur: Number = 20;
  timer = null;
  timer1 = undefined;
  date = "";
  list = [];
  nowTime = new Date();
  list1 = [];
  formatTime(n) {
    //判断是否需要加0
    if (n < 10) {
      return "0" + n;
    } else {
      return n;
    }
  }
  FormatTime() {
    //返回显示的日期时间格式
    var date = new Date();
    var year = this.formatTime(date.getFullYear());
    var month = this.formatTime(date.getMonth() + 1);
    var day = this.formatTime(date.getDate());
    var hour = this.formatTime(date.getHours());
    var minute = this.formatTime(date.getMinutes());
    var second = this.formatTime(date.getSeconds());
    var weekday = date.getDay();
    var weeks = new Array(
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    );
    var week = weeks[weekday];
    this.date = `${year}年${month}月${day}日`;
    return ` ${week} ${hour}:${minute}:${second} `;
  }
  baoxin = {
    header: ["时间", "位置", "温度", "湿度"],
    data: [],
    // index: true,
    // indexHeader: "#",
    rowNum: 5,
    // headerBGC: "rgba(0, 255, 255, 1)", //表头
    headerBGC: "none", //表头
    oddRowBGC: "none", //奇数行
    evenRowBGC: "rgba(0, 255, 255, 0.1)", //偶数行
    columnWidth: ["60", "140", "80", "80"],
    align: ["center", "center", "center", "center"],
  };
  created() {
    this.timer1 = setInterval(() => {
      this.nowTime = new Date();
    });
    this.getInairList();
    this.getGasList();
    this.getTrapList();
    this.getCount();
    this.getoutairlist();
    this.getthlist();
    this.getelist();
    this.getwarninglist();
    this.setTime();
  }
  setTime() {
    //每隔十分钟运行一次保存方法
    this.timer = setInterval(() => {
  this.getInairList();
    this.getGasList();
    this.getTrapList();
      this.getCount();
      this.getoutairlist();
      this.getthlist();
      this.getelist();
      this.getwarninglist();
    }, 6000000);
  }
  get outairlist() {
    return this.$store.state.outair_equipment.list;
  }
  //包芯数据
  async getthlist() {
    let data = {
      etype2: 1,
    };
    this.thlist = await this.$store.dispatch({
      type: "thequipment/getscreenThe",
      data: data,
    });
    let arr = [];
    if (this.thlist.length > 0) {
      for (let e in this.thlist) {
        arr.push([
          this.thlist[e].temp1.toFixed(2).toString().padStart(5,'0'),
          this.thlist[e].humi1.toFixed(2).toString().padStart(5,'0'),
          this.thlist[e].temp2.toFixed(2).toString().padStart(5,'0'),
          this.thlist[e].humi2.toFixed(2).toString().padStart(5,'0'),
          this.thlist[e].temp3.toFixed(2).toString().padStart(5,'0'),
          this.thlist[e].humi3.toFixed(2).toString().padStart(5,'0'),
          this.thlist[e].fwName,
          this.thlist[e].etype,
          this.thlist[e].locationName,
        ]);
      }
      let nowData = this.baoxin;
      nowData.data = arr;
      this.baoxin = { ...nowData };
      let a = this.groupedByList1();
      let tlist1 = [];
      for (let i in a) {
        let res = { name: a[i][0][6], list: a[i] };
        tlist1.push(res);
      }
      this.list1 = tlist1;
    }
  }
  groupedByList1() {
    return this.baoxin.data.reduce((list, i) => {
      //获取需要分组的元素
      const data = i[6]; //判断集合中是否已经有该元素集合，没有则添加
      if (!list[data]) {
        list[data] = [];
      }
      list[data].push(i);
      return list;
    }, []);
  } 
  //环境数据
  async getelist() {
    let data = {
      etype2: 0,
    };
    this.elist = await this.$store.dispatch({
      type: "thequipment/getscreenThe",
      data: data,
    });
    let arr = [];
    let fwlist = [];//单个楼层数据
    let totallist = [];
    let ifwname = "";
    let iifwname = "";
    if (this.elist.length > 0) {
      for (let i=0;i<this.elist.length;i++) {
        if(i != 0){
          ifwname = this.elist[i-1].fwName+this.elist[i-1].fName;
          iifwname = this.elist[i].fwName+this.elist[i].fName;
          if(iifwname != ifwname){
            let res = { name: this.elist[i-1].fName, list: arr};
            fwlist.push(res);
            arr = [];
            arr.push([
            this.elist[i].temp1.toFixed(2).toString().padStart(5,'0'),
            this.elist[i].humi1.toFixed(2).toString().padStart(5,'0'),
            ]);
            if(this.elist[i-1].fwName != this.elist[i].fwName){
              let res1 = {fwName:this.elist[i-1].fwName,totallist:fwlist};
              totallist.push(res1);
              fwlist = [];
            }
          }else if(i == this.elist.length - 1){
            arr.push([
              this.elist[i].temp1.toFixed(2).toString().padStart(5,'0'),
              this.elist[i].humi1.toFixed(2).toString().padStart(5,'0'),
              // this.elist[i].fName,
            ]);
            let res = { name: this.elist[i].fName, list: arr};
            fwlist.push(res);
            let res1 = {fwName:this.elist[i].fwName,totallist:fwlist};
              totallist.push(res1);
              fwlist = [];
          }else if(arr.length > 4){
            let res = { name: this.elist[i-1].fName, list: arr};
            fwlist.push(res);
            arr = [];
            arr.push([
            this.elist[i].temp1.toFixed(2).toString().padStart(5,'0'),
            this.elist[i].humi1.toFixed(2).toString().padStart(5,'0'),
            ]);
          }
          else{
          arr.push([
          this.elist[i].temp1.toFixed(2).toString().padStart(5,'0'),
          this.elist[i].humi1.toFixed(2).toString().padStart(5,'0'),
        ]);
        }
        }
        else{
          arr.push([
          this.elist[i].temp1.toFixed(2).toString().padStart(5,'0'),
          this.elist[i].humi1.toFixed(2).toString().padStart(5,'0'),
        ]);
        }
      }
      this.list = totallist;
    }
  }
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
    this.timer = null;
    if (this.timer1) {
      clearInterval(this.timer1);
    }
  }
  //气体浓度
  async getGasList() {
    this.gaslist = await this.$store.dispatch({
      type: "gasequipment/getEquList",
    });
  }
  //烟虫
  async getTrapList() {
    var list = await this.$store.dispatch({
      type: "data/getWeekDatas",
    });
    var xdata = [];
    let ydata = [];
    console.log(list);
    list.forEach((e) => {
      let name = e.addDate.toString().substring(5, 10);
      let value = e.numbler;
      xdata.push(name);
      ydata.push(value);
    });
    let options = {
  grid: {
    // left: '3%',
    // right: '4%',
    // bottom: '3%',
    containLabel: true
  },
  xAxis: {
    data: xdata,
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      show: true
    }
  },
  yAxis: {
    data: 'value',
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      show: false
    },
    splitLine: {
      show: false
    }
  },
  series: [
    {
      type: 'bar',
      data: ydata,
      label: {
        show: true,
        position: 'center',
        offset: [0, 0],
        style: {
          fill: '#fff'
        }
      },
      backgroundBar: {
        show: true
      },
      animationCurve: 'easeOutBounce'
    }
  ]
}
var trapChart = echarts.init(this.$refs.trapChart);
    trapChart.setOption(options);
    //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        trapChart.resize();
      });
    // tdatalist = {
    //   data:[],
    //  // showValue: true,
    //   fontSize: 10,
    // };
    // this.traplist = options;
  }
  //室内设备数据
  async getInairList() {
    let tinlist = [];
    var list = await this.$store.dispatch({
      type: "inairequipment/getEquList",
    });
    list.forEach((e) => {
      let pm25 = {
        title: {
          text: "PM 2.5",
          center: ["50%", "bottom"],
          style: {
            fill: "#fff",
          },
        },
        series: [
          {
            arcLineWidth:8, //*********调整环形宽度
            type: "gauge",
            data: [{ name: "pm2.5", value: e.pm25 }],
            center: ["50%", "60%"],
            axisLabel: {
              formatter: "{value}",
              style: {
                fill: "#fff",
              },
            },
            details: {
              show: true,
              offset: [0, 40],
              formatter: "{value}",
            },
            axisTick: {
              style: {
                stroke: "#fff",
              },
            },
            animationCurve: "easeInOutBack",
          },
        ],
      };
      let pm10 = {
        title: {
          text: "PM 10",
          center: ["50%", "bottom"],
          style: {
            fill: "#fff",
          },
        },
        series: [
          {
            arcLineWidth:8, //*********调整环形宽度
            type: "gauge",
            data: [{ name: "pm10", value: e.pm10 }],
            center: ["50%", "60%"],
            axisLabel: {
              formatter: "{value}",
              style: {
                fill: "#fff",
              },
            },
            details: {
              show: true,
              offset: [0, 40],
              formatter: "{value}",
            },
            axisTick: {
              style: {
                stroke: "#fff",
              },
            },
            animationCurve: "easeInOutBack",
          },
        ],
      };
      let locationName = e.locationName;
      this.Inlocation.push(locationName);
      let data = [pm25, pm10];
      tinlist.push(data);
    });
    this.Inlist = tinlist;
  }
  //预警记录
  async getwarninglist() {
    var list = await this.$store.dispatch({
      type: "thhandlewarning/GetAllwarningList",
    });
    let data = [];
    list.forEach((e) => {
      let item = [
        e.locationName + "-" + e.types + "-超出阈值",
        e.addDate.substring(5, 10),
      ];
      data.push(item);
    });
    this.warninglist = {
      data: [],
      // index: true,
      rowNum: 2,
      oddRowBGC: "none", //奇数行
      evenRowBGC: "rgba(0, 255, 255, 0.1)", //偶数行
      columnWidth: [800, 100],
      align: ["left"],
    };
    this.warninglist.data = data;
  }
  //各个设备总数
  async getCount() {
    this.equlist = await this.$store.dispatch({
      type: "thequipment/getAllEquCount",
    });
  }
  //室外设备数据
  async getoutairlist() {
    this.pagerequest.maxResultCount = 1;
    this.pagerequest.skipCount = 0;
    await this.$store.dispatch({
      type: "outair_equipment/GetRealPaged",
      data: this.pagerequest,
    });
  }
}
